var _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgIconPauseFat = function SvgIconPauseFat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.279999999999998,
    height: 39.82
  }, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y2: 35.82,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 8,
    x2: 4,
    y1: 4,
    x1: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y2: 35.82,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 8,
    x2: 20.28003,
    y1: 4,
    x1: 20.28003
  })));
};
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQuMjc5OTk5OTk5OTk5OTk4IiBoZWlnaHQ9IjM5LjgyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPg0KICAgPGxpbmUgeTI9IjM1LjgyIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2Utd2lkdGg9IjgiIHgyPSI0IiB5MT0iNCIgeDE9IjQiLz4NCiAgIDxsaW5lIHkyPSIzNS44MiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSI4IiB4Mj0iMjAuMjgwMDMiIHkxPSI0IiB4MT0iMjAuMjgwMDMiLz4NCjwvc3ZnPg0K";
export { SvgIconPauseFat as ReactComponent };